import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { Button, CircularProgress, Tabs, Tab } from '@material-ui/core'
import { resetFmcsa, resetFmcsaData } from 'actions/applicants'
import Drawer from 'components/shared/Drawer'
import FmcsaDrawer from '../Tabs/Summary/Summaries/SummaryDrawers/FmcsaDrawer'
import FmcsaSearchContent from './FmcsaSearchContent'
import MotusSearchContent from './MotusSearchContent'
import strings from 'strings'
import './fmcsaSearch.scss'
import { useAppContext } from '../../../../context/AppContext'
import AuthService from '../../../../tools/AuthService'

const FMCSAsearch = (props) => {
    const {
        show,
        onHide,
        getFmcsaData,
        getFmcsaDataByDOT,
        fmcsaData = [],
        history,
        type = '',
        showDetailedReport,
        closeDetailReport,
        detailData,
        creditCosts,
        motusEnabled,
    } = props

    const dispatch = useDispatch()
    const { isDemoMode } = useAppContext()
    const { creditUsageEnabled } = AuthService.getClientFeatures()

    const [loading, setLoading] = useState(false)
    const [showDetailModal, setShowDetailModal] = useState(false)
    const [fmcsaDetail, setFmcsaDetail] = useState({})
    const [selectedValue, setSelectedValue] = useState('dot')
    const [inputValue, setInputValue] = useState({ carrierName: '', MC: '', DOT: '' })
    const [dotNumber, setDotNumber] = useState(detailData?.dotNumber)
    const [searchMode, setSearchMode] = useState('fmcsa')

    useEffect(() => { dispatch(resetFmcsa()) }, [show, dispatch])
    useEffect(() => { setInputValue({ carrierName: '', MC: '', DOT: '' }) }, [selectedValue, show])
    useEffect(() => {
        if (showDetailedReport !== undefined) setShowDetailModal(showDetailedReport)
        if (showDetailedReport !== undefined && detailData) setFmcsaDetail(detailData)
    }, [showDetailedReport, detailData])

    // --- FMCSA handlers ---

    const handleFmcsaSearch = () => {
        const { carrierName, MC, DOT } = inputValue
        if (!carrierName && !MC && !DOT) return

        let params = { 'carrierName:fuzzy': carrierName.trim() }
        if (DOT || MC) {
            params = { ...params, codeType: DOT ? 'DOT' : 'MC', codeValue: DOT || MC }
        }
        setLoading(true)
        getFmcsaData(params, isDemoMode).finally(() => setLoading(false))
    }

    const handleViewClick = (item) => {
        setLoading(true)
        getFmcsaDataByDOT({ codeType: 'DOT', codeValue: item.dotNumber }, isDemoMode)
            .then(res => {
                const mcNumbers = res?.response?.extraContent?.mcNumbers || []
                setFmcsaDetail({ ...res.response.content?.[0]?.carrier, mcNumber: mcNumbers })
                setShowDetailModal(true)
                setDotNumber(item.dotNumber)
            })
            .finally(() => setLoading(false))
    }

    const handleSelectButton = (dot) => {
        history.push(`/create-applicant?codeType=DOT&codeValue=${dot}`)
    }

    const handleCreateApplicationManually = () => {
        dispatch(resetFmcsaData())
        history.push('/create-applicant')
    }

    const getFmcsaCreditCost = () => {
        if (!creditCosts) return 0
        const costObj = creditCosts.find(c => c.requestType === 'FMCSA_SEARCH')
        return costObj ? costObj.creditCost : 0
    }

    // --- Render ---

    const fmcsaModal = (
        <FmcsaDrawer
            open={showDetailModal}
            onClose={() => {
                setShowDetailModal(false)
                if (closeDetailReport) closeDetailReport()
            }}
            data={{ content: { carrier: fmcsaDetail } }}
            fmcsaSearch
            dotNumber={dotNumber}
        />
    )

    const content = (
        <div className='p-3 pb-5'>
            {motusEnabled && (
                <Tabs
                    value={searchMode}
                    onChange={(_, val) => setSearchMode(val)}
                    indicatorColor="primary"
                    textColor="primary"
                    className='mb-3'
                >
                    <Tab label="FMCSA Search" value="fmcsa" />
                    <Tab label="Motus Search" value="motus" />
                </Tabs>
            )}

            {searchMode === 'fmcsa' ? (
                <FmcsaSearchContent
                    loading={loading}
                    selectedValue={selectedValue}
                    onRadioChange={setSelectedValue}
                    inputValue={inputValue}
                    onChange={(e) => {
                        const { id, value } = e.target;
                        setInputValue(v => ({ ...v, [id]: value }));
                    }}
                    onSearch={handleFmcsaSearch}
                    onViewClick={handleViewClick}
                    onSelectButton={handleSelectButton}
                    fmcsaData={fmcsaData}
                    creditUsageEnabled={creditUsageEnabled}
                    creditCosts={creditCosts}
                    creditCost={getFmcsaCreditCost()}
                />
            ) : (
                <MotusSearchContent
                    history={history}
                    creditCosts={creditCosts}
                />
            )}

            {!type && (
                <>
                    <div className='mt-3 mb-3 text-center'>{strings.OR}</div>
                    <div className='d-flex justify-content-center'>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleCreateApplicationManually}
                        >
                            {strings.CREATE_APPLICATION_MANUALLY}
                        </Button>
                    </div>
                </>
            )}

            {fmcsaModal}
        </div>
    )

    if (type === 'quick search' && showDetailedReport) return fmcsaModal
    if (type === 'quick search') return content

    return (
        <Drawer open={show} onClose={onHide} title={strings.DASHBOARD.SEARCH_FOR_BUSINESS}>
            {content}
            {fmcsaModal}
        </Drawer>
    )
}

export default FMCSAsearch